(function() { window.GUID_aa8fd0a2_4e5e_46a0_9b25_2ee6adc7ee0d = { getGuid: function() { return "aa8fd0a2-4e5e-46a0-9b25-2ee6adc7ee0d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            class SupportFix {
                /** Call this function to fix 'requestAnimationFrame' and 'cancelAnimationFrame' vendors and not supported devices*/
                static fixRequestAnimationFrame() {
                    if (!this.fixRequestAnimationFrameAplied) {
                        this.fixRequestAnimationFrameAplied = true;
                        if (!window.requestAnimationFrame) {
                            window.requestAnimationFrame = (function () {
                                return window.webkitRequestAnimationFrame ||
                                    window.mozRequestAnimationFrame || // comment out if FF4 is slow (it caps framerate at ~30fps: https://bugzilla.mozilla.org/show_bug.cgi?id=630127)
                                    window.oRequestAnimationFrame ||
                                    window.msRequestAnimationFrame ||
                                    function (/* function FrameRequestCallback */ callback, /* DOMElement Element */ element) {
                                        return window.setTimeout(callback, 1000 / 60); //60 fps
                                    };
                            })();
                        }
                        if (!window.cancelAnimationFrame)
                            window.cancelAnimationFrame =
                                window['webkitCancelAnimationFrame'] || window['webkitCancelRequestAnimationFrame'] ||
                                    window['mozCancelAnimationFrame'] || window['mozCancelRequestAnimationFrame'] || function (id) { clearTimeout(id); };
                    }
                }
            }
            SupportFix.fixRequestAnimationFrameAplied = false;
            ImageCropperAddons.SupportFix = SupportFix;
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper-supportFix.pre.js.map
